import RefreshIcon from 'components/Icons/RefreshIcon';
import { useHistoryBatch } from 'contexts/HistoryBatch';
import React from 'react';
import { useTranslation } from 'react-i18next';
import DangerIcon from 'components/Icons/DangerIcon';
import { HistoryBatchEmpty } from '../HistoryBatchEmpty';
import { HistoryBatchList } from '../HistoryBatchList';
import HistoryBatchSearch from '../HistoryBatchSearch';
import { HistoryBatchStatus } from '../HistoryBatchStatus';

export const HistoryBatchDesktop = () => {
  const { refresh, loading, isEmpty, isEmptyFilter, tab } = useHistoryBatch();

  const { t } = useTranslation(['history', 'beneficiaries']);

  return (
    <div className="beneficiaries-history">
      <div className="refresh-page">
        <div>
          <DangerIcon />
          <span>{t('attention')}</span>
        </div>

        <button className="refresh-button" type="button" onClick={refresh}>
          <div className={loading && 'refreshing'}>
            <RefreshIcon />
            {t('refresh_page')}
          </div>
        </button>
      </div>

      <div className="lists-wrapper">
        <div className="history">
          {(!isEmpty || isEmptyFilter || tab === '_DS') && <HistoryBatchSearch />}
          {isEmpty ? <HistoryBatchEmpty /> : <HistoryBatchList />}
        </div>
        <div className={`${'details'}${isEmpty ? ' empty' : ''}`}>
          <span className="title">{t('details')}</span>
          {isEmpty && !isEmptyFilter && <span>{t('no_files')}</span>}
          {isEmptyFilter && <span>{t('not_found_details')}</span>}
          {!isEmpty && !isEmptyFilter && <HistoryBatchStatus />}
        </div>
      </div>
    </div>
  );
};
